import React from 'react';
import { Shield, Users, ChevronRight } from 'lucide-react';

const TeamsView = ({ teams, onCreateTeam, onSelectTeam }) => {
    return (
        <div className="flex-1 overflow-y-auto p-4 pb-20 min-h-0">
            {/* Create Team Button */}
            <button
                onClick={onCreateTeam}
                className="w-full mb-4 py-4 rounded-xl bg-gradient-to-r from-neon-cyan/20 to-purple-600/20 border-2 border-dashed border-neon-cyan/50 hover:border-neon-cyan text-neon-cyan flex items-center justify-center gap-3 transition-all hover:scale-[1.02] active:scale-[0.98]"
            >
                <div className="w-10 h-10 rounded-full bg-neon-cyan/20 flex items-center justify-center">
                    <Shield size={20} />
                </div>
                <div className="text-left">
                    <span className="block font-bold">Create Your Team</span>
                    <span className="block text-xs text-gray-400">Start your own squad and invite players</span>
                </div>
            </button>

            <h3 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-3">Your Squads</h3>
            {teams.length === 0 ? (
                <div className="text-center py-10">
                    <Shield size={40} className="mx-auto text-gray-700 mb-3" />
                    <p className="text-gray-500 text-sm">Not part of any team yet.</p>
                    <p className="text-gray-600 text-xs mt-1">Create your own team or search for one to join!</p>
                </div>
            ) : (
                <div className="space-y-3">
                    {teams.map(team => (
                        <div
                            key={team.id}
                            onClick={() => onSelectTeam(team)} // Open Team Modal
                            className="bg-gray-800 p-4 rounded-xl border border-gray-700 hover:border-neon-cyan/50 transition cursor-pointer"
                            style={{ borderLeftColor: team.meta?.theme?.primary || '#333', borderLeftWidth: '4px' }}
                        >
                            <div className="flex items-center gap-4">
                                <div
                                    className="w-14 h-14 rounded-lg flex items-center justify-center font-bold text-xl"
                                    style={{ background: `linear-gradient(135deg, ${team.meta?.theme?.primary || '#444'}, ${team.meta?.theme?.accent || '#666'})` }}
                                >
                                    {team.meta?.name?.charAt(0) || 'T'}
                                </div>
                                <div className="flex-1">
                                    <h4 className="text-white font-bold">{team.meta?.name}</h4>
                                    <span className="text-xs text-gray-500"><Users size={10} className="inline" /> {team.roster ? Object.keys(team.roster).length : 0} members</span>
                                </div>
                                <ChevronRight size={18} className="text-gray-600" />
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TeamsView;
